import { lazy } from "react";
import { Navigate, Route } from "react-router-dom";
import { TENANTS_PATH } from "@/features/admin/tenants/model/tenantsRoutes";

const TenantsPage = lazy(async () => {
  const module = await import("@/features/admin/tenants/ui/TenantsPage");
  return { default: module.TenantsPage };
});

const TenantDetailPage = lazy(async () => {
  const module = await import("@/features/admin/tenants/ui/TenantDetailPage");
  return { default: module.TenantDetailPage };
});

export const adminRouteElements = (
  <>
    <Route path="/" element={<Navigate to={TENANTS_PATH} replace />} />
    <Route path={TENANTS_PATH} element={<TenantsPage />} />
    {/* Before the catch-all below, which would otherwise swallow it. */}
    <Route path={`${TENANTS_PATH}/:id`} element={<TenantDetailPage />} />
    <Route path="*" element={<Navigate to={TENANTS_PATH} replace />} />
  </>
);
